import React, { Component } from 'react';
import { Rating } from '../';
import './dialog.css';

export default class Dialog extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      icon,
      title,
      description,
      type = "confirmation",
      fullscreen = false,
      titleFontSize = "16px"
    } = this.props;
    return (
      <div
        className={`rdp-react-template-component-dialog ${fullscreen ? "fullscreen" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? "dialog-title" : undefined}
        aria-describedby={description ? "dialog-description" : undefined}
      >
        <div className="rdp-react-template-component-dialog-overlay" onClick={() => this.props.onClose()}></div>
        <div className="rdp-react-template-component-dialog-modal">
          <span className={`rdp-react-template-component-dialog-icon ${icon}`}></span>
          <span className="rdp-react-template-component-dialog-close-btn"></span>
          {title && <h5 id="dialog-title" className="rdp-react-template-component-dialog-title" style={{ fontSize: titleFontSize }}>{title}</h5>}
          {description && <p id="dialog-description" className="rdp-react-template-component-dialog-text">{description}</p>}
          {type === "rating" &&
            <div className="rdp-react-template-component-dialog-rating">
              <span className="rdp-react-template-component-dialog-rating-title">Toque para classificar:</span>
              <Rating
                count={5}
                rating={4}
                starWidth={40}
                onSelect={(e) => console.log(e)}
              />
              <span className="rdp-react-template-component-dialog-rating-title" style={{ marginTop: "25px" }}>Escreva uma mensagem(opcional):</span>
              <textarea className="rdp-react-template-component-dialog-rating-textarea"></textarea>
            </div>
          }
          <div className="rdp-react-template-component-dialog-footer">
            <button className="rdp-react-template-component-dialog-footer-btn confirm" onClick={() => this.props.onConfirm()}>Confirmar</button>
            <button className="rdp-react-template-component-dialog-footer-btn cancel" onClick={() => this.props.onClose()}>Cancelar</button>
          </div>
        </div>
      </div>
    );
  }
}
